import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { reviewsPath } from "../consts/seo";

export const ScrollReviewsToTop = () => {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);

  useLayoutEffect(() => {
    const from = previousPath.current;
    previousPath.current = pathname;
    if (pathname !== reviewsPath || !from.startsWith(`${reviewsPath}/`)) return;

    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
    const behavior = reduceMotion ? "auto" : "smooth";
    window.scrollTo({ top: 0, behavior });
    // The shorter reviews page clamps the article's scroll offset and can cancel
    // that first smooth scroll. Repeat it once layout has settled.
    const frame = requestAnimationFrame(() => {
      if (window.scrollY > 0) window.scrollTo({ top: 0, behavior });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname]);

  return null;
};
